import { Skeleton } from "@/components/ui/skeleton";

export const AdditionalInfoSkeleton = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
    {/* Mon approche skeleton */}
    <div className="card">
      <Skeleton className="h-6 w-1/2 mb-4" />
      <Skeleton className="h-4 w-full mb-2" />
      <Skeleton className="h-4 w-full mb-2" />
      <Skeleton className="h-4 w-3/4 mb-2" />
      <Skeleton className="h-4 w-5/6" />
    </div>

    {/* Bon à savoir skeleton */}
    <div className="card">
      <Skeleton className="h-6 w-1/2 mb-4" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-11/12" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
      </div>
    </div>
  </div>
);
